<template>
  <DatePicker
    v-model="date"
    show-button-bar
    showIcon
    :show-on-focus="false"
    :disabled="isDisabled()"
    iconDisplay="button"
    inputId="completionDate"
    class="h-9 w-full"
    input-class="w-full"
    panelClass="bg-white dark:bg-surface-700/80 backdrop-blur-xl"
    dateFormat="m/d/yy"
    @update:model-value="params.setValue(params.node.rowIndex, date)"
    pt:dropdownbutton:root:class="w-[4rem] rounded-l-none"
  />
</template>

<script setup lang="ts">
const props = defineProps(["params"]);

const isDisabled = (): boolean => {
  return props.params.disableInput(props.params.data);
};

const date = ref(props.params.value);
</script>
